<template>
    <div class="checkbox-list form-control" v-bind:key="updateIndex">
        <ul class="list-group checked-list-box">
            <li
                v-for="(c, i) in allItems"
                v-bind:key="'checkBoxes' + i"
                class="checkbox"
            >
                <label>
                    <input
                        type="checkbox"
                        v-bind:value="c.value"
                        ref="items2"
                        v-on:keydown="
                            navigateCheckboxes($event, $refs.items2, i)
                        "
                        v-on:change="itemClicked($event, i)"
                        :checked="c.isChecked"
                        :tabindex="i === 0 ? null : -1"
                    />
                    {{ c.title }}
                </label>
            </li>
        </ul>
    </div>
</template>

<script>
/* eslint no-unused-vars: 'off' */
import common from '@/scripts/common';
import commonModelHelper from '@/scripts/commonModelHelper';
import store from '@/store';

export default {
    props: ['levels', 'selections'],
    computed: {
        selectedItems() {
            const vm = this;
            //return vm.allItems;
            // console.log('vm.allItems', vm.allItems);
            return vm.allItems.map((i) => i.isChecked.toString()).join(', ');
        }
    },
    created: function () {
        const vm = this;
        // vm.statesInAnyYears = commonModelHelper.groupLocations();
        // vm.onlyStatesInAllYears = commonModelHelper.groupLocations(true);
        // vm.statesForSelection = commonModelHelper.getAllLocationsForSelection();
        // vm.listItems = vm.statesInAnyYears.slice(); //Make a copy of the list
        // vm.stateIdsInAnyYears = vm.statesInAnyYears.map((s) => s.stateId);
        // vm.listItems.unshift({
        //     state: 'All Locations',
        //     stateId: 0
        // });

        vm.isReady = true;
    },
    data() {
        var vm = this;
        var listItems = createListItems(vm.levels, vm.selections);
        const parent = {
            isChecked: areAllChecked(listItems),
            title: '(Select All)'
        };
        const allItems = [parent, ...listItems];

        let vmData = {
            listItems,
            parent,
            allItems,
            // statesForSelection: null,
            // onlyStatesInAllYears: null,
            // statesInAnyYears: null,
            // stateIdsInAnyYears: null,
            // listItems: null,
            // statesInAllYearsWithAll,
            // selectedLocation: -1,
            // selectedLocations: [],
            // selectAllDeselected: false,
            store,
            common,
            isReady: false,
            updateIndex: 0,
            clickedItem: null
        };
        // if (store.state.selModel.locations.ids.length > 0) {
        //     vmData.selectedLocation = store.state.selModel.locations.ids[0];
        //     vmData.selectedLocations = store.state.selModel.locations.ids;
        // }
        return vmData;
    },
    methods: {
        updateStore() {
            var vm = this;
            //TODO:
            // store.dispatch('selModel/setLocations', {
            //     selectionType: 'compare',
            //     locationIds: vm.selectedLocations
            // });
            // store.dispatch('selModel/setReadyForNextStep');
        },
        // selectAllStates: function () {
        //     var vm = this;
        //     if (vm.selectAllDeselected)
        //         vm.selectedLocations = vm.stateIdsInAnyYears;
        //     else vm.selectedLocations = [];
        //     vm.updateStore();
        // },
        itemClicked,
        updateModel,
        navigateCheckboxes
    }
};

function navigateCheckboxes(e, items, itemIndex) {
    var vm = this;
    var nextIndex = 0;
    //if (e.code === 'ArrowRight' || e.keyCode === 39 || e.code === 'ArrowDown' || e.keyCode === 40) {
    if (
        e.keyCode === common.keyCodes.ArrowRight ||
        e.keyCode === common.keyCodes.ArrowDown
    ) {
        nextIndex = ++itemIndex;
        if (nextIndex >= items.length) nextIndex = 0;
        items[nextIndex].focus();
        e.preventDefault();
    }
    //if (e.code === 'ArrowLeft' || e.keyCode === 37 || e.code === 'ArrowUp' || e.keyCode === 38) {
    if (
        e.keyCode === common.keyCodes.ArrowLeft ||
        e.keyCode === common.keyCodes.ArrowUp
    ) {
        nextIndex = --itemIndex;
        if (nextIndex < 0) nextIndex = items.length - 1;
        items[nextIndex].focus();
        e.preventDefault();
    }
}

function createListItems(levels, selectedValues) {
    return levels.map((b) => ({
        isChecked: selectedValues.indexOf(b.value) >= 0,
        title: b.title,
        value: b.value
    }));
}

function areAllChecked(listItems) {
    var anyChecked = false;
    var allChecked = true;
    listItems.forEach(function (item, index) {
        if (item.isChecked === true) anyChecked = true;
        else allChecked = false;
    });
    return allChecked ? true : anyChecked ? null : false;
}

function itemClicked(e, itemIndex) {
    var vm = this;

    if (e) e.preventDefault();

    var item = itemIndex === 0 ? vm.parent : vm.listItems[itemIndex - 1];

    if (item.isChecked === true) {
        item.isChecked = false;
        if (itemIndex === 0)
            vm.listItems.forEach((item) => (item.isChecked = false));
    } else {
        item.isChecked = true;
        if (itemIndex === 0)
            vm.listItems.forEach((item) => (item.isChecked = true));
    }

    //NOT THIS
    if (itemIndex > 0)
        vm.parent.isChecked = Boolean(areAllChecked(vm.listItems));

    // if (vm.parent.isChecked === false) {
    //     vm.parent.isChecked = true;
    // }

    //NOT THIS
    vm.updateModel();
    //vm.updateIndex++;
    //vm.selectedItem = itemIndex-1;
    return false;
}

function updateModel() {
    var vm = this;
    var newValue = [];
    vm.listItems.forEach(function (item, index) {
        if (item.isChecked === true) newValue.push(item.value);
    });
    vm.$emit('input', newValue);
}
</script>

<style scoped>
@media (max-width: 767px) {
    .checkbox-list {
        height: inherit;
    }
}
@media (min-width: 768px) {
    .checkbox-list {
        height: 126px;
        max-height: 126px;
        resize: none;
        overflow-y: scroll;
    }
}

.checkbox-list {
    width: 100%;
    box-sizing: border-box;
    overflow: auto;
    background-color: white;
    padding: 5px 5px 5px 5px;
    display: block;
    font-size: 14px;
    line-height: 1.42857143;
    color: #555;
    background-image: none;
    border: 1px solid #ccc;
    border-radius: 4px;
    -webkit-box-shadow: inset 0 1px 1px rgb(0 0 0 / 8%);
    box-shadow: inset 0 1px 1px rgb(0 0 0 / 8%);
    -webkit-transition: border-color ease-in-out 0.15s,
        -webkit-box-shadow ease-in-out 0.15s;
    -o-transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
    transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
    cursor: pointer;
}
@media (max-width: 767px) {
    .checkbox-list[data-v-1ebcd844] {
        height: inherit;
    }
}

.checkbox-list:focus div.blue-active {
    border: 1px solid rgb(161, 192, 216);
}
li.checkbox {
    display: block;
    margin-left: 0px;
}

ul.checked-list-box {
    padding-left: 0;
    margin: 0;
}

.parent-check-box,
.item-check-box {
    cursor: pointer;
    line-height: 22px;
    color: darkslategrey;
    padding: 0 4px 0 4px;
}

/*.item-check-box {
    margin-left: 4px;
  }*/

.glyphicon {
    margin-right: 4px;
}

/*.glyphicon.glyphicon-check {
    margin-left: -4px;
  }*/

/*.a-check-box.unchecked::before {
    content: '□';
    font-size: larger;
  }

  .a-check-box.indeterminate::before {
    content: '△';
    font-size: larger;
  }

  .a-check-box.checked::before {
    content: '■';
    font-size: larger;
  }*/

/*.book__chapter {
    display: block;
    position: reletive;
    margin-left: 40px;
  }*/

label {
    width: 100%;
    overflow: auto;
    display: block;
}

/* input[type='checkbox'] { */
/* opacity: 0; */
/* margin-left: -13px; */
/* width: 0px; */
/* } */

/* .glyphicon-check.selected:before {
    border: 4px solid rgb(161, 192, 216);
} */

/* input[type='checkbox']:focus {
    background-color: yellow;
} */

/* background-color: yellow; */
/* border: 4px solid rgb(161, 192, 216); */
/* input[type='checkbox']:focus:before {    
    width: 12px;
    margin-left: -18px;
    position: relative;
    top: 1px;
    display: inline-block;
    font-family: 'Glyphicons Halflings';
    font-style: normal;
    font-weight: 400;
    line-height: 1.2;
    -webkit-font-smoothing: antialiased;
    font-size: 15px;
    border: none;
    margin-top: -5px;
}

label.glyphicon-check > input[type='checkbox']:focus:before {
    content: '\e067';
}

label.glyphicon-unchecked > input[type='checkbox']:focus:before {
    content: '\e157';
}

label.glyphicon-stop > input[type='checkbox']:focus:before {
    content: '\e074';
} */
</style>
